import { Draft, ProductReference, SharingDraft } from '@/types';
import { isSameDraft } from '@/model/draft/isSameDraft';

interface ProductHistoryItem {
  product: ProductReference;
  draft: SharingDraft;
}

const productHistory: ProductHistoryItem[] = [];

export const addProductToHistory = (product: ProductReference, sharingDraft: SharingDraft) => {
  productHistory.push({ draft: sharingDraft, product });
};

export const getExistingProductId = (draft: Draft) => {
  const existingItem = productHistory.find((historyItem) => isSameDraft(historyItem.draft, draft));

  if (existingItem) {
    return existingItem.product;
  }

  return null;
};
